import type { NonI18nFieldValidator } from '#src/app/shared/form/validators';
import { nonI18nRequiredValidator } from '#src/app/shared/form/validators';

import type { BaseFilterType } from '../types';

export const filterTypeValidator = nonI18nRequiredValidator({ message: 'Filter type is required.' });

export const filterValueValidator = nonI18nRequiredValidator({ message: 'Filter value is required.' });

function countryFilterValid(andFilters: BaseFilterType) {
	// Using find to return on the first instance
	const countryWithSiblings = andFilters.find((orFilters) => {
		const countryFilter = orFilters.find((value) => value.type === 'country');
		if (countryFilter && orFilters.length > 1) {
			return true;
		}
		return false;
	});

	return !!countryWithSiblings;
}

export function inclusionFieldValidator({ isBase }: { isBase: boolean }): NonI18nFieldValidator<BaseFilterType> {
	return (values, _, _field) => {
		// Apply validation rules for inclusions
		// Inclusions:
		//   Must have at least 1 filter, if they are base
		//   Must include 1 country filter if they are base
		//   Empty allowed if they are not base
		//   Country filters must not belong to an OR clause (They should be alone)
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (!values && isBase) {
			return 'At least one country inclusion selection is required';
		}
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (values) {
			if (isBase) {
				const hasCountryFilter = values.some((filter) => filter.some((f) => f.type === 'country'));
				if (!hasCountryFilter) {
					return 'At least one country inclusion selection is required';
				}
			}
			return countryFilterValid(values)
				? 'Whoops you can\'t add an "OR" to a country filter, please remove'
				: undefined;
		}
		return undefined;
	};
}

export function exclusionFieldValidator(): NonI18nFieldValidator<BaseFilterType> {
	return (values, _, _field) => {
		// Apply validation rules for exclusions
		// Exclusions:
		//   Can be empty
		//   Country filters must not belong to an OR clause (They should be alone)
		// eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
		if (!values) {
			return undefined;
		}

		return countryFilterValid(values) ? 'Whoops you can\'t add an "OR" to a country filter, please remove' : undefined;
	};
}
